module.exports = "/virtual-football-league/img/amblems/right/logos/REAL VALLADOLID.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/REAL VALLADOLID.png
// module id = 2224
// module chunks = 4